import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ArticleState} from "@/interfaces/state";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {Article} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ArticleParams} from "@/modules/article/params";
import {createArticle, deleteArticle, editArticle, listArticles, singleArticle} from "@/modules/article/services";

@Module({ dynamic: true, name: "articles", store })
class ArticleModule extends VuexModule implements ArticleState {
    data: IdMapper<Article> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ArticleParams = new ArticleParams();

    @Mutation
    private MAP_ARTICLES(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas.map((article: Article, index: number) => {
            idMapper[article.id] = { ...article, stt: index + 1 };
            return article.id;
        })
        this.data = idMapper;
    }

    @Mutation
    private UPDATE_PARAMS_ARTICLE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_ARTICLE(payload: any) {
        this.ids = this.ids.filter((id: number) => id !== payload);
        delete this.data[payload];
    }

    @Action({ rawError: true })
    public async createArticle(payload: any) {
        await createArticle(payload);
    }

    @Action({ rawError: true })
    public async singleArticle(payload: any) {
        const { data } = await singleArticle(payload);
        return data.data;
    }

    @Action({ rawError: true })
    public async editArticle(payload: any) {
        await editArticle(payload.id, payload);
    }

    @Action({ rawError: true })
    public async deleteArticle(payload: any) {
        await deleteArticle(payload);
        this.DELETE_ARTICLE(payload);
    }

    @Action({ rawError: true })
    public async listArticles(params: any) {
        const { data } = await listArticles(params);
        console.log(data);
        this.MAP_ARTICLES(data);
    }

    @Action({ rawError: true })
    public updateParams(payload: any) {
        this.UPDATE_PARAMS_ARTICLE(payload);
    }
}

export const ArticleStore = getModule(ArticleModule);